import { LocalizedStringsMethods } from "react-localization";
import { DynamicFormControl } from "../../../";
import { getLocalizedStringMethods, localizeText, useTranslateDetection } from "../../helpers/translate-helper";
import { FormGroup, FormLabel, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useRef, useState } from "react";
import { useEffect } from "react";
import Signature, { SignatureRef } from "@uiw/react-signature";

function SignatureControl(props: DynamicFormControl) {
    const { currentLanguage } = useTranslateDetection();

    const [value, setValue] = useState<string | null>(props.value ?? null);
    const [defaultPoints, setDefaultPoints] = useState<Record<string, number[][]>>(getDefaultPoints(props.value))
    const $svg = useRef<SignatureRef>(null);


    let strings: LocalizedStringsMethods | null = getLocalizedStringMethods(props, currentLanguage);
    let label = props.label;

    if (strings != null && label != null) {
        const localization = localizeText(strings, label);
        label = localization.localization;
    }

    function getDefaultPoints(value: string | null | undefined): Record<string, number[][]> {
        if (value == null){
            return {};
        }

        const points1 = JSON.parse(value);
        return {points1};
    }

    const onPointer = (data: number[][]) => {
        if (data == null || data.length === 0) {
            return;
        }

        const stringData = JSON.stringify(data);

        updateValue(stringData);
    }

    const updateValue = (data: string | undefined | null) => {
        if (props.setState && data != undefined) {
            props.setState(data);
            setValue(data);
        }
    };

    const clearCanvas = () => {
        $svg.current?.clear();
        updateValue(null);
    };

    return (
        <FormGroup id={props.id}>
            <div style={{ display: 'flex', justifyContent: 'space-between' }}>
                <FormLabel>{label}</FormLabel>
                <IconButton aria-label="delete" size="small" disabled={props.disabled} onClick={() => clearCanvas()}>
                    <CloseIcon fontSize="inherit" />
                </IconButton>
            </div>
            <Signature defaultPoints={defaultPoints} ref={$svg} options={{}} style={{ borderRadius:"5px", border: "1px solid", minHeight: "150px" }} readonly={props.disabled} onPointer={(data) => onPointer(data)} />
        </FormGroup>
    )
}


export default SignatureControl;